import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../../_metronic/layout/core'
import { BDMenu } from './BDMenu'
import { WithChildren } from '../../../../../../_metronic/helpers'
import { FC, Suspense } from 'react'
import TopBarProgress from 'react-topbar-progress-indicator'
import { CreditListWrapper } from '../../../settings/settting-modules/credit-buyer/creditList'
import { CreateComit } from '../../../settings/settting-modules/processing-routes/CreateCommit'
import { EngagementWrapper } from '../../../settings/settting-modules/credit-buyer/Engagment'
import { getCSSVariableValue } from '../../../../../../_metronic/assets/ts/_utils'
import { Fullfillment } from '../../../settings/settting-modules/Fullfillment/Fullfillment'
import { CouponsWrapper } from '../../../settings/settting-modules/Coupons/Coupons'
import { MembershipWrapper } from '../../../settings/settting-modules/Membership-tire/MembershipTire'
const usersBreadcrumbs: Array<PageLink> = [
    {
        title: 'Business development',
        path: '/apps/business-development',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const usersBreadcrumbs2: Array<PageLink> = [
    {
        title: 'Pricing Template',
        path: '/apps/settings',
        isSeparator: false,
        isActive: false,
    },
    {
        title: '',
        path: '',
        isSeparator: true,
        isActive: false,
    },
]

const BDPage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route index element={<BDMenu />} />
                <Route
                    path='impact-partner'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Impact Partner</PageTitle>
                            <CreditListWrapper />
                        </>
                    }
                />

                <Route
                    path='membership-tiers'
                    element={
                        <>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Impact Partner Tier</PageTitle>
                            <MembershipWrapper />
                        </>
                    }
                />


                <Route
                    path='My-Portfolio'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>My Portfolio</PageTitle>
                            {/* <CommitmentForm /> */}
                            <CreateComit />
                        </SuspensedView>
                    }
                />
                <Route
                    path='engagement'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Engagement</PageTitle>
                            <EngagementWrapper />
                        </SuspensedView>
                    }
                />
                <Route
                    path='fullfilment'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Fullfilment</PageTitle>
                            <Fullfillment />
                        </SuspensedView>
                    }
                />



                <Route
                    path='coupons'
                    element={
                        <SuspensedView>
                            <PageTitle breadcrumbs={usersBreadcrumbs}>Coupons</PageTitle>
                            <CouponsWrapper />
                        </SuspensedView>
                    }
                />

            </Route>
        </Routes>
    )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    TopBarProgress.config({
        barColors: {
            '0': baseColor,
        },
        barThickness: 1,
        shadowBlur: 5,
    })
    return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default BDPage

